import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,[_c(VCardTitle),_c(VCardText,[_c(VAlert,{directives:[{name:"t",rawName:"v-t",value:('auth.changePasswordSuccessfully'),expression:"'auth.changePasswordSuccessfully'"}],attrs:{"color":"success","icon":"check_circle","outlined":""}})],1),_c(VCardActions,[_c(VSpacer),_c(VBtn,{directives:[{name:"t",rawName:"v-t",value:('common.close'),expression:"'common.close'"}],attrs:{"color":"grey","outlined":""},on:{"click":function($event){return _vm.$emit('close')}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }